<template id="limitation-modal-template">
    <base-form :do="save" :v-errors="error" class="flex flex-col" id="limitation-modal">
        <div class="modal-body content">
            <div v-if="genericError" class="form-error text-xs mb-4">{{ genericError }}</div>

            <div class="group fields">
                <text-input class="w-full" label="Titel" name="title" type="text" v-model="limitation.title"
                    maxlength="100" v-validate="'required|max:100'" data-vv-as="Titel" :error="errors.first('title')"
                    :has-permission="true" :required="true"></text-input>

                <text-input class="w-full" label="Materiaal" name="material" type="text"
                    v-model="limitation.material" maxlength="100" v-validate="'required|max:100'"
                    data-vv-as="Materiaal" :error="errors.first('material')" :has-permission="true"
                    :required="true"></text-input>

                <div class="field-group">
                    <div class="field-heading">
                        <label class="required">Omschrijving&nbsp;</label>
                    </div>
                    <textarea class="textarea" name="desc" rows="4" v-model="limitation.desc"
                        v-validate="'required'" data-vv-as="Omschrijving"></textarea>
                    <transition name="slide">
                        <span v-if="errors.first('desc')" class="block form-error text-xs">
                            {{ errors.first('desc') }}
                        </span>
                    </transition>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-tertiary btn-sm" v-if="limitation.id"
                @click="deleteLimitation">Verwijder</button>
            <button type="button" class="btn btn-tertiary btn-sm" @click="close">Cancel</button>
            <button type="submit" class="btn btn-primary btn-sm">Opslaan</button>
        </div>
    </base-form>
</template>

<script>
import LimitationService from '@/services/limitation';
import BaseForm from '@/components/globals/BaseForm';
import TextInput from '@/components/inputs/Text';

import { EventBus } from '@/event-bus';
import { mapMutations } from 'vuex';
import { HIDE_MODAL } from '@/store/mutations.types';

export default {
    name: 'LimitationModal',
    $_veeValidate: {
        validator: 'new'
    },
    components: {
        BaseForm,
        TextInput
    },
    data() {
        return {
            inventoryId: null,
            limitation: {
                title: '',
                material: '',
                desc: ''
            },
            error: null,
            genericError: null
        };
    },
    created() {
        const payload = this.clone(this.$store.state.modal.items);
        this.inventoryId = payload.inventoryId;

        if (payload.limitation) {
            this.limitation = payload.limitation;
        }
    },
    methods: {
        ...mapMutations('modal', {
            hide: HIDE_MODAL
        }),
        clone(obj) {
            return JSON.parse(JSON.stringify(obj));
        },
        close() {
            this.$validator.reset();
            this.hide();
        },
        async save() {
            this.genericError = null;

            try {
                if (this.limitation.id) {
                    const { data: response } = await LimitationService.update(this.limitation.id, this.limitation);
                    EventBus.$emit('limitation-saved', response.data);
                } else {
                    const { data: response } = await LimitationService.create(this.inventoryId, this.limitation);
                    EventBus.$emit('limitation-added', response.data);
                }
                this.close();
            } catch (error) {
                if (error.data && error.data.details) {
                    this.error = error.data;
                    return;
                }
                this.genericError = 'Opslaan van de beperking is mislukt.';
            }
        },
        async deleteLimitation() {
            if (!confirm('Weet je zeker dat je deze beperking wilt verwijderen?')) {
                return;
            }

            try {
                await LimitationService.delete(this.limitation.id);
                EventBus.$emit('limitation-deleted', this.limitation);
                this.close();
            } catch (error) {
                this.genericError = 'Verwijderen van de beperking is mislukt.';
            }
        }
    }
};
</script>
